import Checkbox from '@jetbrains/ring-ui/components/checkbox/checkbox'
import type {SelectItem} from '@jetbrains/ring-ui/components/select/select'
import Select from '@jetbrains/ring-ui/components/select/select'
import * as React from 'react'

import type {DefaultProps, Props} from './Sorter.types'

import styles from './Sorter.css'

const getItem = (name: string): SelectItem => ({
  key: name,
  label: name,
})

class Sorter extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    dimensions: [],
  }

  handleSelect = (item: SelectItem | null) => {
    const {descending, onChange} = this.props
    onChange(String(item?.key), descending)
  }

  handleCheck: (arg0: React.SyntheticEvent<HTMLInputElement>) => void = e => {
    const {dimension, onChange} = this.props
    onChange(dimension, e.currentTarget.checked)
  }

  render(): React.ReactNode {
    const {descending, dimension, dimensions} = this.props
    return (
      <React.Fragment>
        <label>
          {'Sort by '}
          <Select
            size={Select.Size.S}
            selected={getItem(dimension)}
            onChange={this.handleSelect}
            data={dimensions.map(getItem)}
          />
        </label>
        <Checkbox
          checked={descending}
          onChange={this.handleCheck}
          containerClassName={styles.checkbox}
        >
          {'in descending order'}
        </Checkbox>
      </React.Fragment>
    )
  }
}

export default Sorter
